import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';
import { facebookURL, IconFacebook, IconInstagram, IconPinterest, IconTwitter, instagramURL, pinterestURL, twitterURL } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "./FooterSocialMedia.styles";
import { FooterPromo } from "../FooterPromo/FooterPromo";
var SocialMediaLink = function SocialMediaLink(_ref) {
  var children = _ref.children,
    href = _ref.href,
    title = _ref.title;
  var _useTrackableLink = useTrackableLink(),
    trackLinkClick = _useTrackableLink.trackLinkClick,
    trackLinkMouseDown = _useTrackableLink.trackLinkMouseDown;
  var trackingEvent = {
    event: 'custom_event',
    event_action: 'Social click',
    event_category: 'Footer',
    event_label: title
  };
  return /*#__PURE__*/React.createElement(_StyledA, {
    href: href,
    onClick: trackLinkClick(trackingEvent),
    onMouseDown: trackLinkMouseDown(trackingEvent),
    rel: "noreferrer",
    target: "_blank",
    title: title,
    $_css: styles.icon
  }, children);
};
export var FooterSocialMedia = function FooterSocialMedia() {
  return /*#__PURE__*/React.createElement(FooterPromo, {
    intro: "Follow us for epic gifts and inspo",
    title: "Get social"
  }, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css2: styles.container
  }, /*#__PURE__*/React.createElement(SocialMediaLink, {
    href: facebookURL,
    title: "Facebook"
  }, /*#__PURE__*/React.createElement(_StyledIconFacebook, {
    $_css3: styles.icon
  })), /*#__PURE__*/React.createElement(SocialMediaLink, {
    href: twitterURL,
    title: "Twitter"
  }, /*#__PURE__*/React.createElement(_StyledIconTwitter, {
    $_css4: styles.icon
  })), /*#__PURE__*/React.createElement(SocialMediaLink, {
    href: pinterestURL,
    title: "Pinterest"
  }, /*#__PURE__*/React.createElement(_StyledIconPinterest, {
    $_css5: styles.icon
  })), /*#__PURE__*/React.createElement(SocialMediaLink, {
    href: instagramURL,
    title: "Instagram"
  }, /*#__PURE__*/React.createElement(_StyledIconInstagram, {
    $_css6: styles.icon
  }))));
};
var _StyledA = _styled("a")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledIconFacebook = _styled3(IconFacebook)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledIconTwitter = _styled4(IconTwitter)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledIconPinterest = _styled5(IconPinterest)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledIconInstagram = /*#__PURE__*/_styled6(IconInstagram).withConfig({
  displayName: "FooterSocialMedia___StyledIconInstagram",
  componentId: "sc-mij0h8-0"
})(["", ""], function (p) {
  return p.$_css6;
});